import { Effect, pipe } from 'effect';

// Constants
import { END_POINTS } from '@/constants';

// Services
import { httpClient } from '@/services/http';

// Types
import { HttpMethod, RequestConfig } from '@/types';
import { Resume } from '@shared/types';

// Utils
import { handleActionError } from '@/utils';

interface GetUserResumeByIdParams {
  resumeId: string;
  requestConfig?: RequestConfig;
}

export const getUserResumeById = async ({
  resumeId,
  requestConfig,
}: GetUserResumeByIdParams) =>
  Effect.runPromise(
    pipe(
      Effect.tryPromise({
        try: () =>
          httpClient<Resume>(END_POINTS.GET_USER_RESUME_BY_ID(resumeId), {
            method: HttpMethod.GET,
            retry: { attempts: 2 },
            ...requestConfig,
          }),
        catch: (error) => handleActionError<Resume>(error),
      }),
      Effect.catchAll((error) => Effect.succeed(error)),
    ),
  );
